import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'jquery.caret';
import 'at.js';
import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';
import isEqual from 'lodash.isequal';

const EditableDev = styled(ContentEditable)`
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
  border: 1px solid #b9b9b9;
  font-size: 16px;
  border-radius: 3px;
  
  ${p => !p.autoHeight ?
    `height: ${p.height ?? '200px'};` :
    `
      min-height: ${p.height ?? '200px'};
      height: auto;
      max-height: 1000px;
    `
  }
  overflow: ${p => p.hideOverflow ? 'auto' : 'scroll'};
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  max-width: ${p => p.fullpage ? '100%' : 'calc(50vw - 26px)'};
  min-width: 400px;
  background: ${p => p.fullpage ? '#f9f9f9' : 'none'};
  resize: ${p => p.resizable ? 'vertical' : 'none'};

  :focus {
    border-color: #49a9ee;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
  }

  a:visited,
  a:hover {
    color: #108ee996;
  }

  &[disabled] {
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    cursor: not-allowed;

  }
  &[contenteditable=true]:empty:before {
    content: attr(placeholder);
    display: block;
    color: #aaa;
    cursor: text;
  }
`;

const Nav = suggestion =>
  `<li id=${suggestion.objectId}>
    <span class='tags-nav-span'>
      <span class='tags-nav-span-child'>
        <i class='fa fa-${suggestion.icon}'></i>
        ${suggestion.type}:
      </span>
      <span>
        ${suggestion.description.includes(`${suggestion.type}:`) ?
    suggestion.description.replace(`${suggestion.type}:`, '') :
    suggestion.description
  }
      </span>
    </span>
  </li>`;


const TagsArea = ({
  tags = [],
  onChange,
  value,
  height = '200px',
  disabled,
  fullPage = false,
  addLinkedObject,
  placeholder = '',
  resizable = false,
  autoHeight = false,
  hideOverflow = false,
}) => {
  const contentEditable = useRef();

  const checkTags = () => {
    if (tags.length > 0) {
      const tagWeights = [
        { tag: 'customer', weight: 1 },
        { tag: 'installedat', weight: 2 },
        { tag: 'equipment', weight: 3 },
        { tag: 'order', weight: 5 },
        { tag: 'technician', weight: 6 },
      ];
      const weightedTags = tags?.map((t) => {
        const foundWeight = tagWeights?.find(w => w.tag === t.type);
        if (foundWeight) {
          return {
            ...t,
            weight: foundWeight.weight,
          };
        }
        // If no weighted tag is found, default it to below.
        return {
          ...t,
          weight: 100,
        };
      });

      const sortedTags = weightedTags?.sort((a, b) => a.weight - b.weight);
      /* eslint-disable no-template-curly-in-string */
      $(contentEditable?.current?.getEl())
        .atwho({
          at: '#',
          data: sortedTags,
          insertTpl:
            // eslint-disable-next-line max-len
            "<a contentEditable='false' href='/${type}/${objectId}?context=${objectId}' target='_blank'>${description}</a>",
          displayTpl: Nav,
          callbacks: {
            beforeInsert: (insertedValue, $li) => {
              if (addLinkedObject) {
                addLinkedObject($li[0].getAttribute('id'));
              }
              return insertedValue;
            },
          },
        })
        .on('inserted.atwho', () => {
          const element = $(contentEditable?.current?.getEl());
          // get rid of the wrapper span & add space
          element?.find('span.atwho-inserted a').unwrap();
          // Set caret position after the space
          const pos = element.caret('pos');
          element.caret('pos', pos);
        });

      document.execCommand('defaultParagraphSeparator', false, 'br');
      /* eslint-enable no-template-curly-in-string */
    }
  };

  useEffect(() => {
    if (contentEditable?.current && !disabled) {
      checkTags();
    }
  }, [tags?.length, contentEditable?.current, disabled]);

  const handleChange = (evt) => {
    onChange(evt.target.value);
  };

  return (
    <EditableDev
      height={height}
      fullpage={fullPage ? 1 : 0}
      ref={contentEditable}
      html={value || ''}
      onChange={handleChange}
      disabled={disabled}
      // https://github.com/lovasoa/react-contenteditable/pull/64
      placeholder={placeholder}
      resizable={resizable}
      autoHeight={autoHeight}
      hideOverflow={hideOverflow}
    />
  );
};

TagsArea.propTypes = {
  tags: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string,
  height: PropTypes.string,
  disabled: PropTypes.bool,
  fullPage: PropTypes.bool,
  addLinkedObject: PropTypes.func,
  placeholder: PropTypes.string,
  resizable: PropTypes.bool,
  autoHeight: PropTypes.bool,
  hideOverflow: PropTypes.bool,
};

export default React.memo(
  TagsArea,
  (p, n) => isEqual(p.tags, n.tags) && p.value === n.value && p.disabled === n.disabled,
);
